<template>
  <div>
    <list
      row-key="RoleId"
      ref="list"
      unit="菜单"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="角色名称">
          <el-input v-model="params.Name" placeholder="请填写角色名称" clearable />
        </el-form-item>
        <el-form-item label="角色类型">
          <el-select v-model="params.RoleType" clearable>
            <el-option value="3" label="品牌" v-if="loginInfo.UserType==3" />
            <el-option value="0" label="运营商" />
            <el-option value="1" label="驾校" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="params.Status" clearable>
            <el-option value="1" label="正常" />
            <el-option value="0" label="屏蔽" />
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="RoleName" label="角色名称"/>
        <el-table-column prop="RoleType" label="角色类型">
          <template slot-scope="{row}">
            <span v-if="row.RoleType===0">运营商</span>
            <span v-else-if="row.RoleType===1">驾校</span>
            <span v-else-if="row.RoleType===3">品牌</span>
          </template>
        </el-table-column>
        <el-table-column prop="Sn" label="序号"/>
        <el-table-column prop="Status" align="center" label="状态" width="80">
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.Status">正常</el-tag>
            <el-tag type="danger" v-else>屏蔽</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
var loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
import list from "@/components/common/list";
import listMixin from "@/mixins/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/sy/role").default,
      loginInfo,
      params: {
        Name: "",
        RoleType: null,
        Status: null,
      },
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>